import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Biz360Logo } from "../components/layout/Biz360Logo";
import { PublicFooter } from "../components/layout/PublicFooter";

export const RetractationPage = () => {
  const navigate = useNavigate();
  const subject = encodeURIComponent("Demande de rétractation - Biz360");
  const body = encodeURIComponent(
    `Bonjour,

Je vous notifie par la présente ma rétractation du contrat d'abonnement au service Biz360.

- Nom et prénom : 
- Adresse email du compte : 
- Date de souscription : 
- Date de réception de la confirmation : 
- Motif (facultatif) : 
- Date de la demande : 
- Signature : 

Cordialement,`
  );

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Biz360Logo />
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            data-testid="back-home-btn"
          >
            <ArrowLeft size={16} /> Retour
          </button>
        </div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-10" data-testid="retractation-page">
        <h1 className="text-3xl font-bold mb-2" style={{ color: "#210875" }}>
          Formulaire de rétractation
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          Conformément à l'article L221-18 du Code de la consommation
        </p>

        <Section title="Votre droit de rétractation">
          <p>
            Vous disposez d'un délai de <strong>14 jours</strong> à compter de la date de
            souscription à votre abonnement Biz360 pour exercer votre droit de rétractation, sans
            avoir à justifier de motifs ni à payer de pénalités.
          </p>
          <div
            className="rounded-md p-4 mt-3"
            style={{ backgroundColor: "#FFF8E1", borderLeft: "4px solid #F59E0B" }}
          >
            <p className="text-sm">
              <strong>⚠️ Important :</strong> si vous avez expressément demandé à accéder
              immédiatement au service lors de votre souscription et que vous avez renoncé à votre
              droit de rétractation (article L221-28 du Code de la consommation), ce formulaire ne
              s'applique pas.
            </p>
          </div>
          <p className="mt-3">
            Pour exercer ce droit, complétez et envoyez ce formulaire par email à{" "}
            <a
              href="mailto:t.samblat@gmail.com"
              className="underline"
              style={{ color: "#210875" }}
            >
              t.samblat@gmail.com
            </a>{" "}
            avant l'expiration du délai de 14 jours.
          </p>
        </Section>

        <Section title="Formulaire à compléter et à envoyer">
          <p>
            <strong>À l'attention de :</strong>
            <br />
            Tiphaine SAMBLAT — Biz360
            <br />
            Adresse postale indiquée dans les{" "}
            <a
              href="/mentions-legales-cgu"
              className="underline"
              style={{ color: "#210875" }}
            >
              mentions légales
            </a>
            <br />
            <a
              href="mailto:t.samblat@gmail.com"
              className="underline"
              style={{ color: "#210875" }}
            >
              t.samblat@gmail.com
            </a>
          </p>

          <p className="mt-4">
            « Je vous notifie par la présente ma rétractation du contrat d'abonnement au service
            Biz360. »
          </p>

          <ul className="mt-3 space-y-1 text-sm">
            <li>• Nom et prénom : _________________________</li>
            <li>• Adresse email du compte : _________________________</li>
            <li>• Date de souscription : _________________________</li>
            <li>• Date de réception de la confirmation : _________________________</li>
            <li>• Motif (facultatif) : _________________________</li>
            <li>• Date de la demande : _________________________</li>
            <li>• Signature : _________________________</li>
          </ul>

          <a
            href={`mailto:t.samblat@gmail.com?subject=${subject}&body=${body}`}
            className="inline-block mt-6 px-5 py-2.5 rounded-md text-white font-semibold hover:opacity-90 transition"
            style={{ backgroundColor: "#210875" }}
            data-testid="retractation-email-btn"
          >
            ✉️ Pré-remplir l'email de rétractation
          </a>
        </Section>

        <Section title="Traitement de votre demande">
          <ul className="space-y-2">
            <li>• Accusé de réception par email sous 24h ouvrées</li>
            <li>
              • Remboursement effectué dans les <strong>14 jours</strong> suivant la réception, via
              le même moyen de paiement que celui utilisé lors de la souscription
            </li>
            <li>• Désactivation de votre compte à la date de rétractation</li>
          </ul>
          <p className="mt-3 text-sm text-muted-foreground">
            Ce formulaire peut également être envoyé par courrier postal à l'adresse de l'éditeur
            indiquée dans nos{" "}
            <a
              href="/mentions-legales-cgu"
              className="underline"
              style={{ color: "#210875" }}
            >
              mentions légales
            </a>
            .
          </p>
        </Section>
      </main>

      <PublicFooter />
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-bold mb-3" style={{ color: "#210875" }}>
      {title}
    </h2>
    <div className="text-sm text-muted-foreground space-y-2 leading-relaxed">{children}</div>
  </section>
);

export default RetractationPage;
